<app-auth-shell>
  <div class="access_heading">
    <h1>Sign in</h1>
    <p>Use your Smart TOS account to continue.</p>
  </div>

  <div class="method_switch" role="group" aria-label="Sign in with">
    <button type="button" [class.active]="loginMethod === 'email'" [attr.aria-pressed]="loginMethod === 'email'"
            (click)="switchLoginMethod('email')">Username
    </button>
    <button type="button" [class.active]="loginMethod === 'phone'" [attr.aria-pressed]="loginMethod === 'phone'"
            (click)="switchLoginMethod('phone')">Phone
    </button>
  </div>

@if (loginMethod === 'email') {
  <form [formGroup]="emailLoginForm" (ngSubmit)="submitEmailLogin()">
    <div class="input_with_label">
      <label for="username" class="required_field_label">Username</label>
      <input
        id="username"
        name="username"
        formControlName="username"
        type="text"
        placeholder="Enter your username"
        required
        autocomplete="username"
        [ngClass]="{
      form_error:
        emailLoginForm.get('username')?.invalid &&
        emailLoginForm.get('username')?.touched &&
        emailLoginForm.get('username')?.errors
    }"
      />
      <div
        class="validation_error"
        *ngIf="
      emailLoginForm.get('username')?.invalid &&
      emailLoginForm.get('username')?.touched
    "
      >
        <small *ngIf="emailLoginForm.get('username')?.errors?.['required']"
        >Username is required</small
        >
      </div>
    </div>


    <div class="input_with_label">
      <label for="password" class="required_field_label">Password</label>
      <div class="password_field">
        <input
          id="password"
          name="password"
          formControlName="password"
          [type]="showPassword ? 'text' : 'password'"
          placeholder="Enter your password"
          required
          autocomplete="current-password"
          [ngClass]="{
      form_error:
        emailLoginForm.get('password')?.invalid &&
        emailLoginForm.get('password')?.touched &&
        emailLoginForm.get('password')?.errors
    }"
        />
        <button
          type="button"
          class="toggle-password-btn"
          aria-label="Toggle password visibility"
          (click)="toggleShowPassword()"
        >
          <app-svg-icon [path]="showPassword ? 'assets/icons/view_icon.svg' : 'assets/icons/eye-off.svg'" />
        </button>
      </div>
      <div
        class="validation_error"
        *ngIf="
      emailLoginForm.get('password')?.invalid &&
      emailLoginForm.get('password')?.touched
    "
      >
        <small *ngIf="emailLoginForm.get('password')?.errors?.['required']"
        >Password is required</small
        >
      </div>
    </div>
    <div class="form_meta">
      <a href="/forgot-password" class="text_link">Forgot password?</a>
    </div>
    <button type="submit" class="primary_button sign_in_btn" [disabled]="isLoading">
      @if (isLoading) {
        <app-svg-icon [path]="'assets/gifs/spinner.svg'" style="height: 24px;width: 24px;background: #FFF"></app-svg-icon>
      } @else {
        Sign in
      }
    </button>
  </form>
}
@if (loginMethod === 'phone') {
  <form [formGroup]="phoneLoginForm" (ngSubmit)="submitPhoneLogin()">
    <div class="input_with_label">
      <label for="mobile" class="required_field_label">Phone Number</label>
      <input
        id="mobile"
        name="mobile"
        formControlName="mobile"
        type="tel"
        placeholder="Enter your phone number"
        required
        autocomplete="new-phone"
        maxLength="10"
        [ngClass]="{
      form_error:
        phoneLoginForm.get('mobile')?.invalid &&
        phoneLoginForm.get('mobile')?.touched &&
        phoneLoginForm.get('mobile')?.errors
    }"
      />
      <div
        class="validation_error"
        *ngIf="
      phoneLoginForm.get('mobile')?.invalid &&
      phoneLoginForm.get('mobile')?.touched
    "
      >
        <small *ngIf="phoneLoginForm.get('mobile')?.errors?.['required']"
        >Phone number is required</small
        >
        <small *ngIf="phoneLoginForm.get('mobile')?.errors?.['pattern']"
        >Enter 10 digits</small
        >
      </div>
    </div>
    @if (isOtpGenerated) {
      <!-- <div class="otp_sent_success">
        OTP sent successfully to your phone number
      </div> -->
      <div class="input-with-label">
        <label for="otp" class="required_field_label">OTP</label>
        <app-otp-input
          [ngClass]="{
      form_error:
        phoneLoginForm.get('otp')?.invalid &&
        phoneLoginForm.get('otp')?.touched &&
        phoneLoginForm.get('otp')?.errors
    }"
          id="otp"
          (otpChange)="onOtpChange($event)"
        ></app-otp-input>
        <div
          class="validation_error"
          *ngIf="
      phoneLoginForm.get('otp')?.invalid &&
      phoneLoginForm.get('otp')?.touched
    "
        >
          <small *ngIf="phoneLoginForm.get('otp')?.errors?.['required']"
          >OTP is required</small
          >
          <small *ngIf="phoneLoginForm.get('otp')?.errors?.['pattern']"
          >Enter 6 digits</small
          >
        </div>
        <div class="phone_login_options spaced_flex_container">
          <div><span class="countdown" *ngIf="!resendAllowed">Resend OTP in {{ formatTime(countdown) }}
            seconds</span></div>
          <div><a [ngClass]="{ disabled: !resendAllowed }" (click)="resendOtp()">Resend OTP</a></div>
        </div>
      </div>
      <button type="submit" class="primary_button sign_in_btn" [disabled]="isLoading">
        @if (isLoading) {
          <app-svg-icon [path]="'assets/gifs/spinner.svg'" style="height: 24px;width: 24px;background: #FFF"></app-svg-icon>
        } @else {
          Sign in
        }
      </button>
    } @else {
      <button type="button" class="primary_button sign_in_btn" (click)="requestOtp()">
        Get OTP
      </button>
    }
  </form>
}

  <p class="access_help">Locked out or forgot your username? Contact your terminal administrator.</p>
</app-auth-shell>
